import { render, staticRenderFns } from "./BaseCRUDPageLayout.vue?vue&type=template&id=9475408e&scoped=true&"
import script from "./BaseCRUDPageLayout.vue?vue&type=script&lang=js&"
export * from "./BaseCRUDPageLayout.vue?vue&type=script&lang=js&"
import style0 from "./BaseCRUDPageLayout.vue?vue&type=style&index=0&id=9475408e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9475408e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VBreadcrumbsItem,VCol,VContainer,VIcon,VRow,VSpacer})
